import { Button, Group, Stack } from "@mantine/core";
import { DatePickerInput, DatesProvider } from "@mantine/dates";
import { PERIOD_OPTIONS, PeriodPreset } from "./statsShared";

interface StatsPeriodPickerProps {
  period: PeriodPreset;
  customDate: Date;
  onPeriodChange: (period: PeriodPreset) => void;
  onCustomDateChange: (date: Date) => void;
}

export const StatsPeriodPicker = ({
  period,
  customDate,
  onPeriodChange,
  onCustomDateChange,
}: StatsPeriodPickerProps) => {
  return (
    <DatesProvider settings={{ locale: "hr", firstDayOfWeek: 1 }}>
      <Stack gap="xs">
        <Group gap="xs" wrap="wrap">
          {PERIOD_OPTIONS.map((option) => (
            <Button
              key={option.value}
              size="xs"
              variant={period === option.value ? "filled" : "light"}
              onClick={() => onPeriodChange(option.value)}
            >
              {option.label}
            </Button>
          ))}

          {period === "custom-date" && (
            <DatePickerInput
              value={customDate}
              onChange={(value) => {
                if (!value) return;
                onCustomDateChange(value);
              }}
              valueFormat="DD.MM.YYYY"
              maxDate={new Date()}
              dropdownType="popover"
              size="xs"
              w={140}
            />
          )}
        </Group>
      </Stack>
    </DatesProvider>
  );
};
